export default __webpack_public_path__ + "static/media/volleyball-mockup.7bc71acb.png";